// src/services/ParentRequestService.js
import api from "../../services/api";
import { ENDPOINTS } from "../../services/endpoints";

// --- Parent Request APIs ---

/**
 * Fetch all parent requests by status
 * @param {string} status - 'pending', 'approved', 'rejected'
 */
export const getParentRequests = (status, id_number) =>
  api.get(ENDPOINTS.PARENT_REQUEST.GET, { params: { status, id_number } });

/**
 * Approve parent request
 * @param {number|string} id - request ID
 */
export const approveRejectParentRequest = (data) =>
  api.post(`${ENDPOINTS.PARENT_REQUEST.APPROVE_REJECT_REQUEST}`, { data });
